import {Component, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {ProgressbarComponent} from '../../components/progressbar/progressbar.component';
import {DdosAttackConfigComponent} from '../ddos-attack-config/ddos-attack-config.component';
import {DdosAttackResultsComponent} from '../ddos-attack-results/ddos-attack-results.component';
import {ConfigService} from './config.service';
import {UserService} from '../../user/user.service';
import {TrialService} from '../../trial/trial.service';
import {SystemInformationService} from '../../systeminformation/systeminformation.service';
import {ModalService} from '../../modals/modal.service';



@Component({
    selector: 'config',
    templateUrl: './config.component.html',
    styleUrls: [
        './config.component.scss',
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css'
    ]
})
export class ConfigComponent implements OnInit {
    @ViewChild('progressBar') private progressBar: ProgressbarComponent;
    @ViewChild('attackResults') private attackResults: DdosAttackResultsComponent;
    @ViewChild('attackConfig') private attackConfig: DdosAttackConfigComponent;

    private currentAttackSubscription: Subscription;

    showCostControlAlert: boolean = false;
    consume: any = 0;
    threshold: any = 0;

    thresholdExceededSub: Subscription;
    trialStatusSubscription: Subscription;
    trialMode: boolean = false;
    trialModeExpired: boolean = false;
    trialData: string;

    showDevDurations: boolean = true;



    constructor(
        private cfgService: ConfigService,
        private userService: UserService,
        private trialService: TrialService,
        private systemInformationService: SystemInformationService,
        private modalService: ModalService) { }

    percentComplete: number = 0;
    timeRemaining: string ='';
    status: string = '';

    ngOnInit() {

        this.systemInformationService.getSystemInformation().subscribe(information => {
            if(information['ShowDevDurations'] != null){
                this.showDevDurations = information['ShowDevDurations']
            }
        });



        this.trialStatusSubscription = this.trialService.trialStatusChanged
            .subscribe(
                (response) =>{
                    if(response.trialMode){
                        this.trialMode = response.trialMode;
                        this.trialModeExpired = response.trialModeExpired;
                        this.trialData = response.trialData;
                    }else{
                        this.trialMode = response.trialMode;
                        this.consume = response.consume;
                        this.threshold = response.threshold;
                    }


                }
            );

        this.thresholdExceededSub = this.trialService.thresholdExceeded
            .subscribe(
                (value) =>{
                    this.showCostControlAlert = value;
                }
            );


        this.currentAttackSubscription = this.cfgService.currentAttackSubject
            .subscribe(attack => {
                if(attack){
                    let runningTime = attack && attack.StartDate && (((attack.StopDate ? Date.parse(attack.StopDate) : new Date().getTime()) - Date.parse(attack.StartDate)) / 1000);
                    this.percentComplete = Math.floor((runningTime/attack.AttackParams.Duration) *100);
                    if(runningTime){
                        this.timeRemaining = this.cfgService.convertSecondsToHHMMSS(attack.AttackParams.Duration - runningTime);
                        this.progressBar.updateProgress(this.percentComplete, this.timeRemaining+' '+this.determineStatusString(attack.Status, attack.AttackParams.Duration - runningTime));
                    }else{
                        this.progressBar.updateProgress(0, '00:00:00');
                    }

                    if(attack.Status === 'Stopped'){
                        this.progressBar.updateProgress(0 , '');
                    }

                    /*if(!this.trialMode && attack.Status === 'Failed' && attack.FailReason.startsWith('Running the test would exceed')){
                            this.showCostControlAlert = true;
                    }*/
                } else {
                    this.progressBar.updateProgress(0 , '');
                    this.percentComplete = 0;
                }
            });

    }


    determineStatusString(status: string, timeRemaining: number){
        let rtnValue = '';
        switch(status){
            case 'Started':
                rtnValue = 'REMAINING';
                break;
            case 'Stopping':
                rtnValue = '(STOPPING)';
                break;
            case 'Stopped':
                if(+timeRemaining > 0){
                    rtnValue = '(STOPPED)';
                }else{
                    rtnValue = '(COMPLETED)';
                }

                break;
            default:
                rtnValue = '';
                break;
        }
        return rtnValue;
    }

    btnOKCostControl() {
        this.modalService.showLoadingModal('Updating threshold...', false, false);
        this.trialService.updateAccount(this.userService.getCurrentUser().Email)
            .subscribe(
                result => {
                    this.modalService.showLoadingModal(result.message, false, false);

                    //Get latest value
                    this.trialService.getAccountStatus(this.userService.getCurrentUser().Email);

                    //All this message to show for 2 seconds
                    setTimeout(() => {
                        this.modalService.hideLoadingModal();
                    }, 2000);

                    this.showCostControlAlert = false;
                },
                (error: string) => {
                   this.modalService.hideLoadingModal();
                },
            );

    }

    buyNowClick() {
        if(this.showDevDurations) {
            window.location.href = 'https://store-uat.ixiacom.com/product/BreakingPoint-Cloud';
        } else {
            window.location.href = 'https://www.ixiacom.com/products/breakingpoint-cloud';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/main/config/config.component.ts